module.exports = __webpack_public_path__ + "static/media/db-schenker-logo.ebdbeb3b.png";